import {
  type GetSessionsAnalyticsActivityArgs,
  useLazyGetSessionsAnalyticsActivityQuery,
} from '@carboncopyco/data';
import type { Resolution, TimePeriod } from '@carboncopyco/types';
import {
  getDateFromDaysAgo,
  getNowInFormat,
  getTimezoneName,
  useTourAnalytics,
} from '@carboncopyco/utils';
import { useEffect, useMemo, useState } from 'react';
import { SingleBarChart, useGetActivityChartConfig } from '../../../Charts';
import { useTourPageProps } from '../TourPageContext';

export const ActivityOverTime = () => {
  const { organizationId, tourId, workspaceId } = useTourPageProps();
  const { trackTourSelectTimeFilter } = useTourAnalytics({
    location: 'analytics_page',
    tourId,
  });
  const [resolution, setResolution] = useState<Resolution>('day');
  const [timePeriod, setTimePeriod] = useState<TimePeriod>('30');

  const fetchArgs: GetSessionsAnalyticsActivityArgs = useMemo(
    () => ({
      organizationId,
      shortSessions: true,
      internalSessions: true,
      workspaceIds: [workspaceId],
      start: getDateFromDaysAgo(Number(timePeriod)),
      end: getNowInFormat('YYYY-MM-DDTHH:mm:ssZ'),
      timezone: getTimezoneName(),
      resolution,
      tourId: String(tourId),
      resourceTypes: ['tour'],
    }),
    [organizationId, workspaceId, timePeriod, resolution, tourId]
  );

  const [getManagedPresentationOverTimeChart, { data, isFetching, isError }] =
    useLazyGetSessionsAnalyticsActivityQuery();

  useEffect(() => {
    getManagedPresentationOverTimeChart(fetchArgs);
  }, [fetchArgs, getManagedPresentationOverTimeChart]);

  const chartData = useGetActivityChartConfig(data, 'tour', timePeriod);
  const isEmpty = !data?.results.length;

  useEffect(() => {
    if (timePeriod === '7') {
      setResolution('day');
    }
  }, [timePeriod]);

  return (
    <SingleBarChart
      isLoading={isFetching}
      isError={isError}
      isEmpty={isEmpty}
      chartData={chartData}
      resolution={resolution}
      setResolution={setResolution}
      trackEvent={() =>
        trackTourSelectTimeFilter({
          period: timePeriod,
          resolution,
        })
      }
      timePeriod={timePeriod}
      setTimePeriod={setTimePeriod}
      chartHeight={210}
    />
  );
};
